module.exports = __webpack_public_path__ + "static/media/A18040103_10004_3.71ce2879.jpg";